import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import {
  DynamicDialogRef,
  DynamicDialogConfig,
  DialogService,
} from 'primeng/dynamicdialog';
import { getCountries } from 'libphonenumber-js';
import { AppToastService } from 'src/app/shared/services/app-toast.service';
import { CurrencyService } from 'src/app/modules/finance/services/currency.service';

@Component({
  selector: 'app-currency-admin-modal',
  templateUrl: './currency-admin-modal.component.html',
  standalone: false,
  providers: [DialogService],
})
export class CurrencyAdminModalComponent implements OnInit {
  @ViewChild('currencyForm') currencyForm: NgForm | undefined;
  id: number | undefined;
  model: any = {};
  tenantName: string | undefined;
  isGlobalAdmin = false;
  /** Spinner do botão Save durante o submit. */
  submitting = false;

  // Lista completa de países ISO (antes eram só 100 códigos fixos).
  flagOptions = [...getCountries()].sort();

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private readonly currencyService: CurrencyService,
    private readonly toastService: AppToastService,
  ) {}

  ngOnInit(): void {
    this.isGlobalAdmin = this.config.data?.isGlobalAdmin ?? false;

    if (this.config.data?.id) {
      this.id = this.config.data.id;

      // Use row data passed from the list — avoids tenant-filtered getCurrency() failing
      // for currencies that belong to other tenants.
      const row = this.config.data?.row;
      if (row) {
        this.model = {
          id: row.id,
          name: row.name,
          acronym: row.acronym,
          flag: row.flag,
        };
        this.tenantName = row.tenantName;
      }
    }
  }

  /** Mesma checagem manual campo a campo que sempre existiu aqui — mantida em vez de
   *  `currencyForm.valid` porque o `required` do p-select (Flag) não foi validado
   *  contra esse form. */
  get isFormValid(): boolean {
    return !!this.model.name?.trim() && !!this.model.acronym?.trim() && !!this.model.flag;
  }

  newOrSaveRecord() {
    if (!this.model.name?.trim() || !this.model.acronym?.trim() || !this.model.flag) return;
    this.submitting = true;
    const request$ = this.id
      ? this.isGlobalAdmin
        ? this.currencyService.updateAdmin(this.id, this.model)
        : this.currencyService.update(this.id, this.model)
      : this.currencyService.add(this.model);

    request$.pipe(finalize(() => (this.submitting = false))).subscribe({
      next: () => {
        this.toastService.success(
          this.id ? 'Currency Updated' : 'Currency Created',
          this.id ? 'Updated successfully.' : 'Created successfully.',
        );
        this.ref.close('success');
      },
      error: () => {},
    });
  }
}
